import mailSentFailedService from '../../../services/mailSentFailed.service';
import {convertInquiryTypeToText, convertMailTypeToText} from "../../../utils/helpler-utils";

export default {
    async getListMailSentFailed({}, data) {
        return await mailSentFailedService.getListMailSentFailed(data)
            .then(response => {
                if (response.success && response.data) {
                    let result = [];
                    if (response.data.data && response.data.data.length > 0) {
                        result = response.data.data.map(element => {
                            if (typeof element.state_flg !== 'undefined') {
                                if (element.state_flg === -1) {
                                    element.state_flg_text = '削除';
                                } else if (element.state_flg === 0) {
                                    element.state_flg_text = '下書き';
                                } else if (element.state_flg === 1) {
                                    element.state_flg_text = '送信済';
                                } else if (element.state_flg === 2) {
                                    element.state_flg_text = '送信失敗';
                                } else {
                                    element.state_flg_text = '';
                                }
                            }
                            element.type_text = convertMailTypeToText(element.type, element.kinds_name, element.kinds_state);
                            element.inquiry_type_text = convertInquiryTypeToText(element.inquiry_type);
                            return element;
                        })
                    }
                    return Promise.resolve({
                        page : response.data,
                        data : result,
                    });
                } else {
                    return Promise.resolve([]);
                }
            }).catch(error => {
                return Promise.reject(false);
            })
    },

    clearSearchFilter({commit}){
        commit('CLEAR_SERACH_FILTER');
    },
    setMode ({dispatch ,commit}){
        commit('SET_MODE');
    },
}